import { cn } from "@netlify/ui";
import * as React from "react";

const getGapClass = (gap: 1 | 2): string => {
  const gapClasses = {
    1: "tw--m-1 *:tw-m-1",
    2: "tw--m-2 *:tw-m-2",
  };
  return gapClasses[gap];
};

export type InlineSpacerProps = {
  children: React.ReactNode;
  gap?: 1 | 2 | undefined;
};

/**
 * A wrapper component which evenly horizontally spaces its children, wrapping
 * when required.
 */
export const InlineSpacer = ({ children, gap = 2 }: InlineSpacerProps) => {
  return (
    <div>
      <div className={cn("tw-flex", "tw-flex-wrap", getGapClass(gap))}>
        {/* This inner <div> gets given negative margin, to counter the margin
         * given to each child. The additional wrapping div protects against
         * parent components unintentionally overriding the inner div's margin.
         */}
        {children}
      </div>
    </div>
  );
};
